import { createTheme, ThemeOptions } from "@mui/material";
import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { themeBase } from "./_themeBase";

const theme: ThemeOptions = {
  palette: {
    primary: {
      main: "#2D5EAE",
      dark: "#253787",
      light: "#33AE29",
      base: "#E9F4E6",
      accent: "#0A8800",
    },
    components: {
      slider: {
        rail: "#E9F4E6",
        track: "#253787",
        thumbIcon: "#0A8800",
        label: "#253787",
      },
      progressBar: {
        rail: "#D9D9D9",
        track: "#0A8800",
      },
      buttonSelect: {
        backgroundColor: "#BEDAB7",
        textColor: "#2D5EAE",
        backgroundColorActive: "#2D5EAE",
        textColorActive: "#FFFFFF",
        bordeColorActive: "#A3D4E8",
      },
    },
  },
};

export const CustomTheme = createTheme(themeBase, theme);

export const interfaceConfig: InterfaceConfig = {
  name: "kapital_flex",
  home_url: import.meta.env.VITE_URL_HOME_KAPITAL_FLEX,
  aviso_privacidad: import.meta.env.VITE_URL_HOME_KAPITAL_FLEX + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_KAPITAL_FLEX + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "AceleraFlex",
    description:
      "AceleraFlex es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "kapital_flex/portal/logos/favicon.ico",
    ogImage: "https://lendia.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  navbar: {
    logo: "kapital_flex/portal/logos/logo.png",
  },
  lateral: {
    logo_width: 250,
    logo_height: 50,
    logo_dark: "kapital_flex/portal/logos/logo_dark_bg.png",
    bg_light: "#2D5EAE",
    text_light: "#FFFFFF",
    logo_light: "kapital_flex/portal/logos/logo_light_bg.png",
    bg_dark: "#0A8800",
    text_dark: "#FFFFFF",
    image_list: [
      "kapital_flex/portal/lateral/imagen_1.webp",
      "kapital_flex/portal/lateral/imagen_2.webp",
      "kapital_flex/portal/lateral/imagen_3.webp",
      "kapital_flex/portal/lateral/imagen_4.webp",
      "kapital_flex/portal/lateral/imagen_5.webp",
      "kapital_flex/portal/lateral/imagen_6.webp",
      "kapital_flex/portal/lateral/imagen_7.webp",
      "kapital_flex/portal/lateral/imagen_8.webp",
      "kapital_flex/portal/lateral/imagen_9.webp",
      "kapital_flex/portal/lateral/imagen_10.webp",
    ],
    text_list: [
      "Impulsa tu negocio con la flexibilidad de Acelera Flex",
      "Tu crédito, tus reglas, tu crecimiento",
      "Acelera tu empresa con financiamiento ágil y sin complicaciones",
      "La forma más simple de obtener capital para tu PyME",
      "Más liquidez para que tus planes no se detengan",
      "Crecer nunca fue tan sencillo",
      "Las mejores condiciones para acelerar tus proyectos",
      "El empuje que tu empresa necesita, justo a tiempo",
      "Soluciones claras para empresas que quieren más",
      "Decide, impulsa y acelera tu empresa con Acelera Flex",
    ],
  },
  textos_tofu: {
    pm: {
      crear_cuenta: {
        titulo: "Te damos la bienvenida",
        sub_titulo: "",
      },
      registro_datos_personales: {
        titulo: "Creación de cuenta",
        sub_titulo: "",
      },
      validacion_telefono: {
        titulo: "Validación de teléfono",
        sub_titulo: "",
      },
      datos_empresa_pm: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      consulta_ciec: {
        titulo: "Registro de empresa",
        sub_titulo: "",
      },
      uso_de_credito: {
        titulo: "Selección de uso de crédito",
        sub_titulo: "",
      },
      presencia_digital_pm: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
      datos_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      rfc_curp: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      domicilio_accionista: {
        titulo: "Registro del accionista mayoritario",
        sub_titulo: "",
      },
      consulta_buro_nip: {
        titulo: "Validación para consulta buró",
        sub_titulo: "",
      },
      buro_bloqueado: {
        titulo: "Consulta de Buró de Crédito del Accionista Bloqueada",
        sub_titulo: "",
      },
    },

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
      consulta_buro_pfae: {
        titulo: "Consulta Buró",
        sub_titulo: "",
      },
      domicilio_pfae: {
        titulo: "Domicilio",
        sub_titulo: "",
      },
      presencia_digital_pfae: {
        titulo: "Presencia digital",
        sub_titulo: "",
      },
    },
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Cumplo y Avanzo, S.A.P.I. DE C.V., SOFOM E.N.R.", "Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_dY5WpU3RR",
      userPoolClientId: "4v13vepumrl2r94entkcvuukg9",
    },
    guarantee: {
      userPoolId: "us-east-1_EdJB8vOre",
      userPoolClientId: "1gtf94j5udovq9deu5u13bbhvn",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_wiDGP4RIA",
      userPoolClientId: "6qg1j3lbjhss2njfqg86ibf5r5",
    },
    guarantee: {
      userPoolId: "us-east-1_78qrlwJTD",
      userPoolClientId: "451cn0u2mau2ipp479c39d75m5",
    },
  },
};
